export const faqs = [
  {
    question: '踩蘑菇游戏是免费的吗？',
    answer: '是的！踩蘑菇经典版完全免费。重制版基础关卡也免费开放，额外的三个扩展关卡可以通过一次性购买解锁。手游版同样免费下载，不含任何强制付费内容。',
  },
  {
    question: '踩蘑菇支持哪些平台？',
    answer: '踩蘑菇目前支持Windows、Mac、iOS和Android平台。经典版和重制版可以在PC上运行，手游版则覆盖了移动端。所有版本之间支持云存档同步，切换设备无需重新开始。',
  },
  {
    question: '怎么才能获得高分？',
    answer: '获得高分的关键在于连击系统和时间奖励。连续踩踏蘑菇不落地可以获得分数加成，最高10连击可达51200分。同时尽量快速通关，剩余时间会以每秒50分转换为奖励分数。踩中彩虹蘑菇可以触发双倍分数模式，抓住这个机会刷分效果翻倍。',
  },
  {
    question: '反弹跳怎么操作？',
    answer: '反弹跳的操作时机非常关键：当你踩中蘑菇的瞬间（约0.1秒窗口期），再次按下跳跃键，角色会以1.5倍高度弹起。建议先在第二关的红色蘑菇上反复练习，直到熟练掌握这个时机。成功时角色身上会出现特殊的光效提示。',
  },
  {
    question: '隐藏关卡怎么进入？',
    answer: '游戏中目前有三个隐藏关卡：倒置世界（在第三关特定位置静止5秒）、像素怀旧关（集齐所有彩虹蘑菇后自动触发）、蘑菇王国（第五关Boss房左侧墙壁隐藏入口）。每个隐藏关卡都有完全不同的玩法和丰厚的奖励。',
  },
  {
    question: '游戏卡住了怎么办？',
    answer: '如果角色卡在墙壁或平台中，尝试快速左右移动或使用暂停菜单中的"重置角色位置"功能。如果是游戏进程卡住（如无法触发下一关），请检查是否遗漏了当前关卡的过关条件。大多数情况下重启游戏即可解决，你的存档会自动保存不用担心。',
  },
  {
    question: '初学者应该先从哪个版本开始？',
    answer: '如果你是第一次接触踩蘑菇，推荐从重制版开始。重制版提供了"辅助模式"，可以开启跳跃轨迹预览，大幅降低上手难度。对于完全没有游戏经验的新手，手游版的自动奔跑功能也很友好。经典版更适合已经有一定基础、追求原汁原味体验的玩家。',
  },
  {
    question: '如何联系踩蘑菇的开发团队？',
    answer: '你可以通过本网站的"联系我们"页面发送消息，我们通常会在24小时内回复。也可以在各大社交平台搜索"踩蘑菇官方"找到我们。游戏内的"反馈"功能也是直接联系开发团队的好方式，我们会认真阅读每一条玩家反馈。',
  },
];